import type { IconSvgObject } from './types';

const DartIcon: IconSvgObject = [
  ["path", { d: "M19.5 4.5L22 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 18.5L6.5 17.5L5.5 22H2V18.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 6L18 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7.5 16.5L18.553 9.90098C20.2537 8.78093 20.498 6.38195 19.0581 4.94194C17.6182 3.50192 15.2194 3.74632 14.0994 5.44713L7.5 16.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M6.5 17.5L7.5 16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default DartIcon;
